import {ReactElement} from "react"
import {FormInstance} from "antd"
import {TBoatInfo} from "@ui/api/user"

export type TBoatInfoPageProps = {
  form?: FormInstance<TBoatInfo>
  onShowHint: (prop: keyof TBoatInfo) => void
}

type TBoatInfoHeaderProps = {
  title: string
  text?: string
}

export const BoatInfoHeader = ({title, text}: TBoatInfoHeaderProps): ReactElement => {
  return (
    <div className="header">
      <div className="title">{title}</div>
      {text && <div className="text">{text}</div>}
    </div>
  )
}
